class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    if(this.querySelector('#CartDrawer-Overlay')){
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
    this.watchCartPrice(); // ✅
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      setTimeout(() => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') 
          ? this.querySelector('.drawer__inner-empty') 
          : document.getElementById('CartDrawer');
    
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }

        this.disableCheckoutIfZero();
      }, 50);
    }, { once: true });

    this.disableCheckoutIfZero();

    if(window.location.href.includes('view=login-lead')){
      let priceElement = document.querySelector('.totals__subtotal-value .money');
      let priceText = priceElement.textContent || priceElement.innerText;
      let priceValue = priceText.replace(/[^0-9]/g, '') + '00';
      console.log(priceValue);
      spanPriceLogin(priceValue);
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  disableCheckoutIfZero() {
    const priceElement = this.querySelector('.totals__subtotal-value .money');
    const checkoutBtn = this.querySelector('[name="checkout"], #CartDrawer-Checkout, a[href="/checkout"]');

    if (!priceElement || !checkoutBtn) return;

    const priceValue = parseInt(priceElement.textContent.replace(/[^0-9]/g, ''), 10);
    const isZero = priceValue === 0;

    checkoutBtn.disabled = isZero;
    checkoutBtn.setAttribute('aria-disabled', isZero);
    checkoutBtn.style.pointerEvents = isZero ? 'none' : '';
    checkoutBtn.style.opacity = isZero ? '0.4' : '';
  }

  // ✅ Single observer watching entire drawer — works even after AJAX replaces HTML
  watchCartPrice() {
    const observer = new MutationObserver(() => {
      this.disableCheckoutIfZero();
    });

    observer.observe(this, { childList: true, characterData: true, subtree: true });
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.disableCheckoutIfZero();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function CartDrawerUpdate(selector, section_id, drawer, item_count){
  var t = selector;
  let i = document.createElement("div");
  i.innerHTML = section_id;

  t.classList.remove('is-empty');
  t.replaceChild(i.querySelector("#CartDrawer"), t.querySelector("#CartDrawer"));

  let cartLink = document.querySelector('#cart-icon-bubble');

  if(drawer === false && item_count === 0){
    cartLink.querySelector('.cart-count-bubble span').innerText = 0;
    t.classList.add('is-empty');
  } else {
    const newCount = t.querySelector("cart-drawer-items")?.getAttribute('data-cart-count') || 0;
    cartLink.querySelector('.cart-count-bubble span').innerText = newCount;

    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.disableCheckoutIfZero();

    if (!window.location.href.includes('pages/result4')) {
      cartLink.dispatchEvent(new Event('click'));
    }
  }
}